/*****************************************************************************************
 * 설명 : 관리자 > 컨텐츠관리 > 기본 메뉴 설정
 * URI : /admin/cms/menuList
*****************************************************************************************/
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import * as Yup from "yup";

import { Restful } from 'service/restful';
import { getSelectData, lpad, searchOf } from 'service/utils';

import { MESSAGE_DELAY } from 'config/config';

import { ButtonEx, InputEx, SelectEx, ToggleButtonGroupEx } from 'components/inputEx';
import alertMsg from 'components/message';

/*****************************************************************************************
 * 설명 : 함수 선언
*****************************************************************************************/
const TabMenuConfig = ( props ) => {

  /***************************************************************************************
   * 설명 : 변수 선언부
  ***************************************************************************************/
  const [getApi] = Restful();

  const [moduleList, setModuleList] = useState([]);
  const [boardInfoList, setBoardInfoList] = useState([]);
  const [boardList, setBoardList] = useState([]);
  const [boardGroupList, setBoardGroupList] = useState([]);

  const initValues = {
    seq: '',
    siteSeq: '',
    pageCode: '',
    pageName: '',
    pageMenuName: '',
    moduleSeq: '',
    moduleName: '',
    modulePath: '',
    isUse: 1,
    isMainmenuView: 1,
    isMenuView: 1,
    linkUrl: '',
    isRouter: 1,
    isLogin: 0,
    icon: '',
    queryString: '',
    isLinkOpen: 'C',
    boardSeq: '',
    group: ''
  }

  const formik = useFormik({
    initialValues: initValues,
    validationSchema: Yup.object().shape({
      pageName: Yup.string().max(45, "45자리").required('필수'),
      pageMenuName: Yup.string().max(45, "45자리").required('필수'),
      icon: Yup.string().max(255, "255자리").nullable(),
      linkUrl: Yup.string().max(255, "255자리").nullable(),
      queryString: Yup.string().max(1000, "1000자리").nullable(),
    }),
    onSubmit: (values) => {
      let params = {
        program: 'api',
        service: 'cms',
        action: 'setMenuConfig',
        version: '1.0',
        ...values
      }

      // 추가시
      if( values.seq === 0 ) {
        let pageCode = '001';

        // 첫 메뉴일 경우
        if( values.pageCode === '' ) {
          if( props.menuList.length !== 0 )
            pageCode = lpad( parseInt(props.menuList[ props.menuList.length - 1 ].pageCode) + 1, 3, '0');

        // 선택된 메뉴가 있을 경우 하위 번호
        } else {
          let page = searchOf( props.menuList, 'pageCode', values.pageCode );

          if( page.pageCode === undefined ) {
            pageCode = lpad( parseInt(props.menuList[ props.menuList.length - 1 ].pageCode) + 1, 3, '0');

          } else if( page.children === undefined || page.children.length < 1 )
            pageCode = values.pageCode + '001';

          else {
            let length = page.children[ page.children.length - 1 ].pageCode.length;
            pageCode = lpad( parseInt(page.children[ page.children.length - 1 ].pageCode) + 1, length, '0');
          }
        }

        params.pageCode = pageCode;
        formik.setFieldValue("pageCode", pageCode);
      }

      getApi("post", params).then( response => {
        if( response !== undefined && response.data.result ) {
          alertMsg(response.data.message, "S", MESSAGE_DELAY);

          if( props.menuList && props.setMenuList ) {
            /*
            let tmp = findMenuTree(props.menuList, props.data.pageCode);
            tmp.seq = formik.values.seq;
            tmp.siteSeq = formik.values.siteSeq;
            tmp.pageCode = formik.values.pageCode;
            tmp.pageName = formik.values.pageName;
            tmp.pageMenuName = formik.values.pageMenuName;
            tmp.moduleSeq = formik.values.moduleSeq;
            tmp.moduleName = formik.values.moduleName;
            tmp.modulePath = formik.values.modulePath;
            tmp.isUse = formik.values.isUse;
            tmp.isMainmenuView = formik.values.isMainmenuView;
            tmp.isMenuView = formik.values.isMenuView;
            tmp.linkUrl = formik.values.linkUrl;
            tmp.isRoute = formik.values.isRoute;
            tmp.isLogin = formik.values.isLogin;
            tmp.icon = formik.values.icon;
            tmp.queryString = formik.values.queryString;
            tmp.isLinkOpen = formik.values.isLinkOpen;
            tmp.boardSeq = formik.values.boardSeq;
            tmp.group = formik.values.group;
            */

            props.getList();
          }

        } else {
          alertMsg(response.data.message, "E", MESSAGE_DELAY);
        }
      });
    }
  });

  /***************************************************************************************
   * 설명 : 트리 메뉴 구성 시 부모 트리 찾기
  ***************************************************************************************
  const findMenuTree = (menuList, pageCode) => {
    var result;
    menuList.some(o => result = o.pageCode === pageCode ? o : findMenuTree(o.children || [], pageCode));
    return result;
  }

  /***************************************************************************************
   * 설명 : 모듈 리스트 가져오기
  ***************************************************************************************/
  const getModuleList = () => {
    let params = {
      program: 'api',
      service: 'cms',
      action: 'getModuleInfo',
      version: '1.0',
      siteSeq: formik.values.siteSeq
    }

    getApi("get", params).then( response => {
      if( response !== undefined && response.data.result ) {
        setModuleList([
          ...response.data.data.map((item) => {
            return {
              label: item.siteName + ' - ' + item.moduleName,
              value: item.seq
            }
          })
        ]);
      } else {
        setModuleList([]);
      }
    });
  }

  /***************************************************************************************
   * 설명 : 게시판 정보 리스트 가져오기
  ***************************************************************************************/
  const getBoardInfoList = () => {
    let params = {
      program: 'admin',
      service: 'board',
      action: 'getBoardInfoList',
      version: '1.0'
    }

    getApi("get", params).then( response => {
      if( response !== undefined && response.data.result ) {
        setBoardList(getSelectData(response.data.data, 'boardName', 'boardId'));
        setBoardInfoList(response.data.data);
      } else {
        setBoardList([]);
        setBoardInfoList([]);
      }
    });
  }

  /***************************************************************************************
   * 설명 : 게시판 선택 시 그룹 리스트 변경 처리
  ***************************************************************************************/
  useEffect(() => {
    if( props.tabIndex === 0 ) {
      if( formik.values.boardSeq === '' ) {
        setBoardGroupList([]);

      } else {
        let boardData = boardInfoList.filter((item) => {
          return item.seq === formik.values.boardSeq;
        });

        if( boardData.length < 1 ) setBoardGroupList([]);
        else if( boardData[0].group === '' ) setBoardGroupList([]);
        else {
          let group = boardData[0].group.split('|');
          let groupList = group.map((item) => {
            return {
              label: item, value: item
            }
          });

          setBoardGroupList(groupList);
        }
      }
    }

    // eslint-disable-next-line
  }, [formik.values.boardSeq]);

  /***************************************************************************************
   * 설명 : 모듈 변경 시 모듈 정보 표시
  ***************************************************************************************/
  useEffect(() => {
    if( props.tabIndex === 0 ) {
      let node = moduleList.filter((item) => item.seq === formik.values.moduleSeq);

      // 모듈 빈 선택
      if( node.length < 1 || node[0].seq === undefined ) {
        formik.setFieldValue("moduleName", "");
        formik.setFieldValue("modulePath", "");

      } else {
        formik.setFieldValue("moduleName", node[0].moduleName);
        formik.setFieldValue("modulePath", node[0].modulePath);
      }
    }

    // eslint-disable-next-line
  }, [formik.values.moduleSeq])

  /***************************************************************************************
   * 설명 : 사이트 선택 시 처리
  ***************************************************************************************/
  useEffect(() => {
    if( props.tabIndex === 0 ) {
      formik.setFieldValue('siteSeq', props.siteSeq );
    }

    // eslint-disable-next-line
  }, [props.siteSeq]);

  /***************************************************************************************
   * 설명 : 등록/수정 시 처리
  ***************************************************************************************/
  useEffect(() => {
    if( props.tabIndex === 0 ) {

      // 추가 시 처리
      if( props.data.seq === 0 ) {
        let data = {
          ...initValues
        }
        data.seq = 0;
        data.siteSeq = props.siteSeq;
        data.pageCode = props.data?.pageCode || '';

        formik.setValues( data );

      // 수정 시 처리
      } else {
        formik.setValues( props.data );
      }

    }

    // eslint-disable-next-line
  }, [props.data]);

  /***************************************************************************************
   * 설명 : 등록/수정 시 처리
  ***************************************************************************************/
  useEffect(() => {
    if( props.tabIndex === 0 ) {
      // 모듈 리스트 가져오기
      getModuleList();

      // 게시판 정보 가져오기
      getBoardInfoList();

      formik.setValues( initValues );
    }

    // eslint-disable-next-line
  }, []);

  /***************************************************************************************
   * 설명 : html 선언부
  ***************************************************************************************/
  return (
    <>
      { props.siteSeq === '' &&
        <section className="pt10">
          <div className="menu-list-add-background">
            사이트를 선택 후에 '메뉴등록' 혹은 '메뉴선택'을 진행해주세요.
          </div>
        </section>
      }

      {props.siteSeq !== '' &&
        <>
          { ( props.data.seq === undefined || props.data.siteSeq === undefined ) &&
            <section className="pt10">
              <div className="menu-list-add-background">
                메뉴를 선택하시기 바랍니다.
              </div>
            </section>
          }
          { props.data.seq !== undefined && props.data.siteSeq !== undefined &&
            <>
              <section className="pt10">
                <form onSubmit={formik.handleSubmit}>
                  { ( props?.data?.seq === undefined || props?.data?.seq === 0 ) &&
                    <div className="menu-list-add-background">
                      신규 메뉴 추가 중 입니다.
                    </div>
                  }

                  <h4 className="mt20 mb10">※ 메뉴 기본 정보</h4>

                  <table className="input-table">
                    <colgroup>
                      <col style={{width: '10%'}} />
                      <col style={{width: '23%'}} />
                      <col style={{width: '10%'}} />
                      <col style={{width: '23%'}} />
                      <col style={{width: '10%'}} />
                      <col style={{width: '23%'}} />
                    </colgroup>

                    <tbody>
                      <tr>
                        <th scope="row"><label htmlFor="seq">메뉴코드</label></th>
                        <td>
                          <InputEx
                            name="seq"
                            formik={formik}
                            fullWidth={true}
                            disabled={true}
                          />
                        </td>
                        <th scope="row"><label htmlFor="pageName">메뉴명</label></th>
                        <td>
                          <InputEx
                            name="pageName"
                            formik={formik}
                            fullWidth={true}
                          />
                        </td>
                        <th scope="row"><label htmlFor="pageMenuName">페이지명(표시)</label></th>
                        <td>
                          <InputEx
                            name="pageMenuName"
                            formik={formik}
                            fullWidth={true}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th scope="row"><label htmlFor="moduleSeq">모듈선택</label></th>
                        <td>
                          <SelectEx
                            name="moduleSeq"
                            formik={formik}
                            fullWidth={true}
                            data={[
                              {label: '모듈 선택', value: ''}
                            ].concat(moduleList)}
                          />
                        </td>
                        <th scope="row"><label htmlFor="moduleName">모듈명</label></th>
                        <td>
                          <InputEx
                            name="moduleName"
                            formik={formik}
                            fullWidth={true}
                            disabled={true}
                          />
                        </td>
                        <th scope="row"><label htmlFor="modulePath">모듈 Path</label></th>
                        <td>
                          <InputEx
                            name="modulePath"
                            formik={formik}
                            fullWidth={true}
                            disabled={true}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th scope="row"><label htmlFor="isUse">사용여부</label></th>
                        <td>
                          <ToggleButtonGroupEx
                            name="isUse"
                            formik={formik}
                            fullWidth={false}
                            exclusive={true}
                            data={[
                              {label: '사용', value: 1},
                              {label: '사용안함', value: 0}
                            ]}
                          />
                        </td>
                        <th scope="row"><label htmlFor="isMainmenuView">메인메뉴 표시</label></th>
                        <td>
                          <ToggleButtonGroupEx
                            name="isMainmenuView"
                            formik={formik}
                            fullWidth={false}
                            exclusive={true}
                            data={[
                              {label: '사용', value: 1},
                              {label: '사용안함', value: 0}
                            ]}
                          />
                        </td>
                        <th scope="row"><label htmlFor="isMenuView">메뉴 표시</label></th>
                        <td>
                          <ToggleButtonGroupEx
                            name="isMenuView"
                            formik={formik}
                            fullWidth={false}
                            exclusive={true}
                            data={[
                              {label: '사용', value: 1},
                              {label: '사용안함', value: 0}
                            ]}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th scope="row"><label htmlFor="linkUrl">링크주소</label></th>
                        <td>
                          <InputEx
                            name="linkUrl"
                            formik={formik}
                            fullWidth={true}
                            label="쿼리 스트링 제외한 링크 주소"
                          />
                        </td>
                        <th scope="row"><label htmlFor="queryString">QueryString</label></th>
                        <td>
                          <InputEx
                            name="queryString"
                            formik={formik}
                            fullWidth={true}
                            label="?이후의 값"
                          />
                        </td>
                        <th scope="row"><label htmlFor="isLinkOpen">새창 여부</label></th>
                        <td>
                          <ToggleButtonGroupEx
                            name="isLinkOpen"
                            formik={formik}
                            fullWidth={false}
                            exclusive={true}
                            data={[
                              {label: '현재창', value: 'C'},
                              {label: '새창', value: 'N'},
                              {label: '팝업', value: 'P'}
                            ]}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th scope="row"><label htmlFor="isLogin">로그인 여부</label></th>
                        <td>
                          <ToggleButtonGroupEx
                            name="isLogin"
                            formik={formik}
                            fullWidth={false}
                            exclusive={true}
                            data={[
                              {label: '전체접근', value: 0},
                              {label: '로그인 필수', value: 1},
                            ]}
                          />
                        </td>
                        <th scope="row"><label htmlFor="icon">아이콘</label></th>
                        <td>
                          <InputEx
                            name="icon"
                            formik={formik}
                            fullWidth={true}
                            label="Meterial Icon"
                          />
                        </td>
                        <th scope="row"><label htmlFor="isRouter">라우터추가여부</label></th>
                        <td>
                          <ToggleButtonGroupEx
                            name="isRouter"
                            formik={formik}
                            fullWidth={false}
                            exclusive={true}
                            data={[
                              {label: '추가', value: 1},
                              {label: '추가안함', value: 0},
                            ]}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <h4 className="mt20 mb10">※ 게시판 정보</h4>

                  <table className="input-table">
                    <colgroup>
                      <col style={{width: '10%'}} />
                      <col style={{width: '23%'}} />
                      <col style={{width: '10%'}} />
                      <col style={{width: '23%'}} />
                      <col style={{width: '10%'}} />
                      <col style={{width: '23%'}} />
                    </colgroup>

                    <tbody>
                      <tr>
                        <th scope="row"><label htmlFor="boardId">게시판선택</label></th>
                        <td>
                          <SelectEx
                            name="boardId"
                            formik={formik}
                            fullWidth={true}
                            data={[
                              {label: '게시판 선택', value: ''}
                            ].concat(boardList)}
                          />
                        </td>
                        <th scope="row"><label htmlFor="group">게시판그룹</label></th>
                        <td>
                          <SelectEx
                            name="group"
                            formik={formik}
                            fullWidth={true}
                            data={[
                              {label: '게시판그룹 선택', value: ''}
                            ].concat(boardGroupList)}
                          />
                        </td>
                        <th scope="row"></th>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>

                  <footer className="mt10">
                    <div className="right">
                      <ButtonEx
                        title="기본정보 저장"
                        auth={formik.values.seq === 0 || formik.values.seq === '' ? "authWrite" : "authModify"}
                        type="submit"
                        color="primary"
                        variant="contained"
                        className="Btn"
                      />
                    </div>
                  </footer>
                </form>
              </section>
           </>
          }
        </>
      }
    </>
  );
}

/*****************************************************************************************
 * 설명 : default export 선언
*****************************************************************************************/
export default TabMenuConfig;